import styled, { css } from 'styled-components';
import { SonntagIcon } from '@getgrover/ui';

import NavigationLink from 'ggApp/shared/common/NavigationLink';

const Icon = styled(SonntagIcon)`
    margin-right: ${({ theme }) => theme.spacers.L};
    position: relative;
    fill: ${({ theme }) => theme.colors['Level 5']};
`;

const Wrap = styled(NavigationLink)`
    position: relative;
    height: 48px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.Foreground};
    padding: 0 16px;
    &:hover,
    &:focus,
    &:active {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.Foreground};
        ${Icon} {
            fill: ${({ theme }) => theme.colors.Foreground};
        }
    }
`;

const Name = styled.h3`
${({theme}) => css(theme.typography.SuperTinyHeadline)};
    position: relative;
`;

export {
    Wrap,
    Icon,
    Name,
};
